// extracted by mini-css-extract-plugin
export default {"card":"CZ-z","carouselContainer":"DZ-z","carouselContent":"EZ-z"};